"use client";

import { useEffect } from "react";
import { capture } from "@/lib/analytics";
import { trackGaEvent } from "@/lib/gtag";
import { readMarketingCampaign, rememberLandingAudience } from "@/lib/signupAttribution";

/** Writer-acquisition events use fixed audience, action and placement values. */
export function WriterMarketingAnalytics({ page }: { page: string }) {
  useEffect(() => {
    const source = readMarketingCampaign();
    rememberLandingAudience("writer");
    const properties = { page, audience: "writer", ...(source ? { source } : {}) };
    if (source) {
      for (const anchor of document.querySelectorAll<HTMLAnchorElement>("a[data-writer-cta]")) {
        const url = new URL(anchor.href, window.location.origin);
        if (url.origin === window.location.origin && /\/(?:sign-up)$/.test(url.pathname)) {
          url.searchParams.set("src", source);
          anchor.href = url.toString();
        }
      }
    }
    capture("writer_marketing_viewed", properties);
    trackGaEvent("writer_marketing_viewed", properties);
    function onClick(event: MouseEvent) {
      const link = (event.target as HTMLElement | null)?.closest<HTMLElement>("[data-writer-cta]");
      const action = link?.dataset.writerCta;
      if (!action) return;
      const detail = { ...properties, action, location: link.dataset.writerCtaLocation };
      capture("writer_marketing_cta_clicked", detail);
      trackGaEvent("writer_marketing_cta_clicked", detail);
    }
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, [page]);
  return null;
}
